module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/signature2020-3c712d8f56848201d753c157bb926e64.png";